<template>
  
  <v-container fluid grid-list-md align-start>
      <v-layout row wrap align-start justify-start>
        <v-flex xs12>
              <p class="text-sm-center headline">Do you need help?</p>
              <p class="text-sm-center headline">Send us an email and we will reply within 24 hours or as soon as we can. We are open and approachable. If you have a suggestion we'd love to hear from you and to discuss it further.</p>
              <p class="text-sm-center headline">Our email: support@inscoder.com</p>
        </v-flex>        
      </v-layout>
      
    </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

<script>
import axios from 'axios';

export default {
  computed: {
    count () {
    }
  },
  methods: {
  },
  created: function () {
  },
  data () {
    return {
    }
  },
  filters: {
  },
  mounted () {    
  }  
}
</script>